<template>
  <div class="loader">
    <div class="loader__header">
      <div class="loader__user">
        <div class="loader__avatar shimmer"></div>
        <div class="loader__username shimmer"></div>
      </div>
      <div class="loader__options shimmer"></div>
    </div>
    <div class="loader__img shimmer">
    </div>
    <div class="loader__footer">
      <div class="loader_button shimmer"></div>
      <div class="loader_button shimmer"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PostLoader",
};
</script>

<style>
.loader {
  background: var(--loader-color);
  border-radius: 31px;
  overflow: hidden;
  margin-bottom: 20px;
  width: 100%;
  aspect-ratio: 9 / 15;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.loader__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 12px 24px;
  background: var(--loader-box-color);
}

.loader__img {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  background: var(--loader-color);
}

.loader__user {
  display: flex;
  align-items: center;
  gap: 12px;
}

.loader__avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: var(--loader-color);
}

.loader__username {
  width: 88px;
  height: 29px;
  border-radius: 25px;
  background: var(--loader-color);
}

.loader__options {
  width: 24px;
  height: 24px;
  border-radius: 8px;
  background: var(--loader-color);
}

.loader__footer {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: var(--loader-box-color);
}

.loader_button {
  width: 81px;
  height: 36px;
  border-radius: 100px;
  background: var(--loader-color);
}

.shimmer {
  position: relative;
  overflow: hidden;
}

.shimmer::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg,
      transparent,
      var(--loader-animation-color),
      transparent);
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}

@media (max-width:1000px) {
  .loader {
    aspect-ratio: 9 / 16;
  }
}
</style>
